import initialState from './initial.state';
import * as types from '../actions/types.action';

/**
 * Facts about the current page-0 search that are not results: its searchId, which the
 * related-products strip uses to tell whether a response belongs to the search on screen, and the
 * spelling correction graph-product-search applied, if any ("Showing results for milk").
 *
 * Replaced wholesale by each new search's response, and never touched by infinite scroll: the later
 * pages of a corrected search are corrected the same way.
 *
 * Deliberately kept while the next search is in flight: it describes the results on screen, and
 * those stay until the response lands. SearchPage re-runs the search on mount, over the
 * server-rendered results, so clearing it here flashed corrected milk under "mklk" with no banner.
 * SearchPage hides the banner itself whenever it hides the results behind a spinner.
 */
export default function searchMetaReducer(
  state = initialState.searchMeta,
  action
) {
  switch (action.type) {
    case types.GET_SEARCH_RESULTS_SUCCESS:
      return {
        searchId: action.searchId || null,
        query: action.query || null,
        correctedQuery: action.correctedQuery || null,
      };
    case types.GET_SEARCH_RESULTS_FAILED:
      return initialState.searchMeta;
    default:
      return state;
  }
}
